import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const submitQuizLead = async (payload) => {
  const response = await axios.post(`${API}/leads/quiz`, payload);
  return response.data;
};

export const submitContactLead = async (formData) => {
  const response = await axios.post(`${API}/leads/contact`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};